<template>
  <table class="left_header_table">
    <caption></caption>
    <tbody>
    <tr v-for="(item, i) in items"
        :key="i"
        :class="item.type === 'right' ? 'text_right' : ''"
    >
      <th
          :id="i"
          :class="item.type === 'right' ? '--grey50' : ''"
          class="txt_subtitle_1"
      >
        {{ item.title }}
      </th>
      <td :class="item.type === 'right' ? 'txt_subtitle_1 --grey80' : 'txt_body_1 --grey80'">
        {{ item.content }}
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'LeftHeaderTable',
  props: {
    items: Array
  }
}
</script>
<style lang="scss">
.left_header_table {
  color: #000;
  text-align: left;

  tbody {
    tr {
      border-bottom: 1px solid var(--grey20);

      td {
        padding: 11px 0;
      }
    }

    tr:hover {
      background: none;
    }
  }
}
</style>